<div mat-dialog-content>
  @if (loading) {
<mat-progress-bar style="position: static;
      z-index: 1;
      left: 0;
      right: 0;
      top: 50px;
      bottom: 0;" mode="query">
    </mat-progress-bar>
  }
  <div class="col-12">
    @if (response.message !== null && response.message !== undefined) {
      <div>
        <!-- {{response.message}} -->
        <p class="text header-text">Response: </p>
        <p class="text label-text">{{ response.message}}</p>
      </div>
    }
    @if (response.createdAssets !== undefined && response.createdAssets.length > 0) {
      <div>
        <p class="list-inline-item font-weight-bold text-uppercase">
          Created Assets
        </p>
        <!-- list of buttons to navigate -->
        @for (created of response.createdAssets; track created; let i = $index) {
          <ul
            matTooltip="Click to navigate"
            >
            {{
            created.name
            }}
            <button
              (click)="navigateToAsset(created)"
              mat-icon-button
              color="secondary"
              style="position: absolute; right: 5vw"
              >
              <mat-icon class="mat-18">search</mat-icon>
            </button>
            <button
              (click)="pullOwnership(created)"
              mat-icon-button
              color="secondary"
              style="position: absolute; right: 0"
              >
              <mat-icon class="mat-18">history</mat-icon>
            </button>
            <!-- <hr /> -->
            @if (created.history) {
              <div>
                @if (created.openForAssignment === false && created.isHealthSensor === false) {
                  <button
                    (click)="deleteDialog(created, created.history[0].customerName)"
                    mat-raised-button
                    color="warn"
                    >
                    Remove asset ownership
                    <!-- <mat-icon class="mat-18">close</mat-icon> -->
                  </button>
                }
                @if (created.openForAssignment && created.isHealthSensor === false) {
                  <button
                    (click)="navigateToDialog(created)"
                    mat-raised-button
                    color="primary"
                    >
                    Assign asset ownership to customer
                    <!-- <mat-icon class="mat-18">close</mat-icon> -->
                  </button>
                }
                @for (history of created.history; track history; let i = $index) {
                  <ul
                    class="text dashboard-text"
                    click="navigateToCustomer(history)"
                    >
                    {{
                    history.customerName
                    }}:
                    @if (history.whenEnd === null) {
                      <p style="color: green;">
                        <button
                          (click)="navigateToCustomer(history)"
                          mat-icon-button
                          color="secondary"
                          >
                          ({{
                          history.whenBegin | date: "short"
                          }}
                          -
                          Current
                          )
                        </button>
                      </p>
                    }
                    @if (history.whenEnd) {
                      <p>
                        <button
                          (click)="navigateToCustomer(history)"
                          mat-icon-button
                          color="secondary"
                          >
                          ({{
                          history.whenBegin | date: "short"
                          }}
                          -
                          {{
                          history.whenEnd | date: "short"
                          }})
                        </button>
                      </p>
                    }
                  </ul>
                }
              </div>
            }
            @if (created.noOwnership) {
              <div class="text dashboard-text">
                No Asset History:
                <p style="color: red;">
                  <button
                    (click)="navigateToDialog(created)"
                    mat-icon-button
                    color="secondary"
                    >
                    Click to assign asset to customer
                  </button>
                </p>
              </div>
            }
            <!-- <div *ngIf="created.noOwnership">
            <button (click)="navigateToDialog(created)"
              mat-icon-button
            color="secondary">Assign Asset</button>
          </div> -->
          <!-- <hr /> -->
          <br />
          <hr />
        </ul>
      }
    </div>
  }
  <!-- <ng-template #alreadyExist>
  <p class="text dashboard-text">
    This full scout configuration already exists as multiple assets
  </p>
</ng-template> -->
<hr />
@if (response.existingAssets !== undefined && response.existingAssets.length > 0) {
  <div>
    <p
      class="list-inline-item font-weight-bold text-uppercase"
      matTooltip="Navigate to Asset"
      >
      Existing Assets
    </p>
    @for (existing of response.existingAssets; track existing; let i = $index) {
      <ul>
        <!-- <button mat-raised-button (click)="navigateToAsset(existing)" color="primary">{{existing.code}}</button> -->
        {{
        existing.name
        }}
        <button
          (click)="navigateToAsset(existing)"
          mat-icon-button
          color="secondary"
          style="position: absolute; right: 5vw"
          >
          <mat-icon class="mat-18">search</mat-icon>
        </button>
        <button
          (click)="pullOwnership(existing)"
          mat-icon-button
          color="secondary"
          style="position: absolute; right: 0"
          >
          <mat-icon class="mat-18">history</mat-icon>
        </button>
        <!-- <hr /> -->
        @if (existing.history) {
          <div>
            @if (existing.openForAssignment === false && existing.isHealthSensor === false) {
              <button
                (click)="deleteDialog(existing, existing.history[0].customerName)"
                mat-raised-button
                color="warn"
                >
                Remove asset ownership
                <!-- <mat-icon class="mat-18">close</mat-icon> -->
              </button>
            }
            @if (existing.openForAssignment && existing.isHealthSensor === false) {
              <button
                (click)="navigateToDialog(existing)"
                mat-raised-button
                color="primary"
                >
                Assign asset ownership to customer
                <!-- <mat-icon class="mat-18">close</mat-icon> -->
              </button>
            }
            @for (history of existing.history; track history; let i = $index) {
              <ul
                class="text dashboard-text"
                click="navigateToCustomer(history)"
                >
                {{
                history.customerName
                }}:
                @if (history.whenEnd === null) {
                  <p style="color: green;">
                    <button
                      (click)="navigateToCustomer(history)"
                      mat-icon-button
                      color="secondary"
                      >
                      ({{
                      history.whenBegin | date: "short"
                      }}
                      -
                      Current
                      )
                    </button>
                  </p>
                }
                @if (history.whenEnd) {
                  <p>
                    <button
                      (click)="navigateToCustomer(history)"
                      mat-icon-button
                      color="secondary"
                      >
                      ({{
                      history.whenBegin | date: "short"
                      }}
                      -
                      {{
                      history.whenEnd | date: "short"
                      }})
                    </button>
                  </p>
                }
              </ul>
            }
          </div>
        }
        @if (existing.noOwnership) {
          <div class="text dashboard-text">
            No Asset History:
            <p style="color: red;">
              <button
                (click)="navigateToDialog(existing)"
                mat-icon-button
                color="secondary"
                >
                Click to assign asset to customer
              </button>
            </p>
          </div>
        }
        <!-- <div *ngIf="existing.noOwnership">
        <button (click)="navigateToDialog(existing)"
          mat-icon-button
        color="secondary">Assign Asset</button>
      </div> -->
      <hr />
    </ul>
  }
</div>
}
<!-- <ng-template #fullyCreated>
<p class="text dashboard-text">
  This full scout configuration was created as multiple assets
</p>
</ng-template> -->
</div>
<br />
<!-- <hr /> -->
</div>
<div mat-dialog-actions>
  <div class="col-12">
    <button
      class="btn btn-secondary scanner"
      style="right: 0px; position: absolute"
      mat-raised-button
      color="primary"
      (click)="okayClick()"
      >
      <p class="text btn-text">OKAY</p>
    </button>
  </div>
</div>
